// extracted by mini-css-extract-plugin
export default {"label":"contact-information_label__yEmTP","form":"contact-information_form__s4ssp"};